import React from "react";

export function ResetIcon({ color = '#FFF', ...props }) {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.33203 1.66675V5.66675H5.33203" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.6641 12.3335V8.3335H10.6641" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.6652 8.3335L11.5719 11.2402C10.8554 11.957 9.96896 12.4807 8.99534 12.7623C8.02171 13.0439 6.99261 13.0743 6.00407 12.8507C5.01552 12.627 4.09974 12.1565 3.34219 11.4832C2.58463 10.8099 2.00999 9.95564 1.67188 9.00016" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.3254 5.00013C13.9873 4.04466 13.4126 3.1904 12.6551 2.51708C11.8975 1.84375 10.9817 1.37331 9.99317 1.14964C9.00463 0.925966 7.97553 0.956359 7.0019 1.23798C6.02828 1.5196 5.14186 2.04327 4.42536 2.76013L1.33203 5.6668" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
